// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadMoreObserver_root__1CDd4","rootCenter":"LoadMoreObserver_rootCenter__EGqyj","noPaddingBottom":"LoadMoreObserver_noPaddingBottom__2G4rJ"};